// src/components/Slider/Slider.jsx
import React, { useState, useEffect } from "react";
import "./Slider.css";

import hero1 from "../../assets/images/carroussel1.png";
import hero2 from "../../assets/images/carroussel2.png";
import hero3 from "../../assets/images/carroussel3.png";

export default function Slider() {
  const slides = [
    {
      img: hero1,
      title: "Solutions digitales pour entreprises modernes.",
      subtitle: "Sites web, applications mobiles et logiciels adaptés à vos besoins professionnels."
    },
    {
      img: hero2,
      title: "Développement sur mesure",
      subtitle: "Applications web & mobiles performantes."
    },
    {
      img: hero3,
      title: "Innovation & Transformation digitale",
      subtitle: "Nous accompagnons votre croissance avec la technologie."
    },
  ];

  const [index, setIndex] = useState(0);

  const prev = () => setIndex((index - 1 + slides.length) % slides.length);
  const next = () => setIndex((index + 1) % slides.length);

  // ✅ Défilement automatique toutes les 3 secondes
  useEffect(() => {
    const interval = setInterval(() => {
      next();
    }, 3000);
    return () => clearInterval(interval);
  }, [index]);

  return (
    <div className="slider">
      <div
        className="slider-bg"
        style={{ backgroundImage: `url(${slides[index].img})` }}
      >
        <div className="slider-overlay">
          <h2>{slides[index].title}</h2>
          <p>{slides[index].subtitle}</p>
        </div>
      </div>

      <button className="slider-arrow left" onClick={prev} aria-label="Précédent">‹</button>
      <button className="slider-arrow right" onClick={next} aria-label="Suivant">›</button>
    </div>
  );
}
